// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2021 Ericsson and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

:root {
  --theia-open-editors-icon-width: 20px;
}

.theia-open-editors-widget .theia-caption-suffix {
  margin-left: var(--theia-ui-padding);
  font-size: var(--theia-ui-font-size0);
}

.theia-open-editors-widget
  .open-editors-node-row
  .open-editors-prefix-icon-container {
  min-width: var(--theia-open-editors-icon-width);
}

.theia-open-editors-widget
  .open-editors-node-row
  .open-editors-prefix-icon.dirty,
.theia-open-editors-widget
  .open-editors-node-row.dirty:hover
  .open-editors-prefix-icon.dirty {
  display: none;
}

.theia-open-editors-widget
  .open-editors-node-row.dirty
  .open-editors-prefix-icon.dirty {
  display: block;
}

.theia-open-editors-widget
  .open-editors-node-row
  .open-editors-prefix-icon.close {
  display: none;
}

.theia-open-editors-widget
  .open-editors-node-row:not(.dirty)
  .theia-mod-selected
  .open-editors-prefix-icon.close,
.theia-open-editors-widget
  .open-editors-node-row:hover
  .open-editors-prefix-icon.close {
  display: block;
}

.theia-open-editors-widget .open-editors-node-row.group-node,
.theia-open-editors-widget .open-editors-node-row.area-node {
  font-weight: 700;
  text-transform: uppercase;
  font-size: var(--theia-ui-font-size0);
}

.theia-open-editors-widget .open-editors-node-row.area-node {
  font-style: italic;
}

.theia-open-editors-widget .open-editors-inline-actions-container {
  display: flex;
  justify-content: flex-end;
  margin-left: 3px;
  min-height: 16px;
}

.theia-open-editors-widget .open-editors-inline-action a {
  color: var(--theia-icon-foreground);
}

.theia-open-editors-widget .open-editors-inline-action {
  padding: 0px 3px;
  font-size: var(--theia-ui-font-size1);
  margin: 0 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.theia-open-editors-widget
  .open-editors-node-row
  .open-editors-inline-actions-container {
  visibility: hidden;
}

.theia-open-editors-widget
  .open-editors-node-row:hover
  .open-editors-inline-actions-container {
  visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/navigator/src/browser/open-editors-widget/open-editors.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;;;EAGE,+CAA+C;AACjD;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;AACrB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2021 Ericsson and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n:root {\n  --theia-open-editors-icon-width: 20px;\n}\n\n.theia-open-editors-widget .theia-caption-suffix {\n  margin-left: var(--theia-ui-padding);\n  font-size: var(--theia-ui-font-size0);\n}\n\n.theia-open-editors-widget\n  .open-editors-node-row\n  .open-editors-prefix-icon-container {\n  min-width: var(--theia-open-editors-icon-width);\n}\n\n.theia-open-editors-widget\n  .open-editors-node-row\n  .open-editors-prefix-icon.dirty,\n.theia-open-editors-widget\n  .open-editors-node-row.dirty:hover\n  .open-editors-prefix-icon.dirty {\n  display: none;\n}\n\n.theia-open-editors-widget\n  .open-editors-node-row.dirty\n  .open-editors-prefix-icon.dirty {\n  display: block;\n}\n\n.theia-open-editors-widget\n  .open-editors-node-row\n  .open-editors-prefix-icon.close {\n  display: none;\n}\n\n.theia-open-editors-widget\n  .open-editors-node-row:not(.dirty)\n  .theia-mod-selected\n  .open-editors-prefix-icon.close,\n.theia-open-editors-widget\n  .open-editors-node-row:hover\n  .open-editors-prefix-icon.close {\n  display: block;\n}\n\n.theia-open-editors-widget .open-editors-node-row.group-node,\n.theia-open-editors-widget .open-editors-node-row.area-node {\n  font-weight: 700;\n  text-transform: uppercase;\n  font-size: var(--theia-ui-font-size0);\n}\n\n.theia-open-editors-widget .open-editors-node-row.area-node {\n  font-style: italic;\n}\n\n.theia-open-editors-widget .open-editors-inline-actions-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-left: 3px;\n  min-height: 16px;\n}\n\n.theia-open-editors-widget .open-editors-inline-action a {\n  color: var(--theia-icon-foreground);\n}\n\n.theia-open-editors-widget .open-editors-inline-action {\n  padding: 0px 3px;\n  font-size: var(--theia-ui-font-size1);\n  margin: 0 2px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.theia-open-editors-widget\n  .open-editors-node-row\n  .open-editors-inline-actions-container {\n  visibility: hidden;\n}\n\n.theia-open-editors-widget\n  .open-editors-node-row:hover\n  .open-editors-inline-actions-container {\n  visibility: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
